import React from "react"
import './style.css'

function Footer(){
    return(
        <footer className="footer">
           <p>© 2024 | Yasmin Gonçalves. Todos os direitos reservados.</p> 
        </footer>
        
    )
}

export default Footer
